<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'
import UPDATE from '@/components/page/update'

let pushTypes = {
  4: '開戶60分鐘沒有領取',
  5: '開戶24小時沒有領取',
  6: '開戶3天沒有領取',
  7: '開戶3天但沒有激活',
  8: '沒有簽到',
  10: '交易但沒有領取',
  11: '激活沒有上傳銀行卡',
  12: '激活沒有上傳身份證',
  13: '上傳身份證但沒有領取積分',
  14: '上傳銀行卡但沒有領取積分'
}

let taskType = { 1: '签到', 2: '推薦好友', 3: '交易', 4: '凈入金', 5: '开通真实交易账号', 6: '上传身份证', 7: '绑定银行卡', 8: '激活账号' }

export default {
  name: 'list',
  components: {
    tablePage,
    FORM
  },
  created() {

  },
  methods: {

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      }
    },

    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        this.$refs.childTable.defaultGetData(this.queryData)
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: '賬號', field: 'customerNumber', isNumber: true },
          {
            title: '推送類型',
            field: 'pushTypeId',
            type: 2,
            optionList: pushTypes,
            multiple: false
          },
          {
            title: '活動類型',
            field: 'taskTypeId',
            type: 2,
            optionList: taskType,
            multiple: false
          },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.quantityTask.jpushMsgInfo,
        selection: false,
        sequence: true,
        method: 'get',
        cols: [
          {
            title: '推送時間', field: 'executeTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber' },
          {
            title: '推送類型', field: 'pushTypeId', render: (data, full) => {
              return pushTypes[data]
            }
          },
          {
            title: '積分類型', field: 'taskTypeId', render: (data, full) => {
              return taskType[data]
            }
          },
          { title: '推送原因', field: 'remark' },
          { title: 'alias', field: 'alias' }
        ]
      }
    }
  }
}
</script>
